module.exports = __webpack_public_path__ + "img/illustration_eye.be66f9a9.png";